/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Serializer for inviting a teacher.
 */
export interface InviteTeacher { 
    /**
     * Email pedagoga
     */
    email: string;
    /**
     * Křestní jméno
     */
    firstName: string;
    /**
     * Příjmení
     */
    lastName: string;
    /**
     * Seznam klíčových slov rolí (např. ['director', 'teacher'])
     */
    teacherGroupKeywords: Array<string>;
}